import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import TrainingLibrary from './pages/TrainingLibrary';
import Dashboard from './pages/Dashboard';
import Apps from './pages/Apps';
import AppSetup from './pages/AppSetup';
import Videos from './pages/Videos';
import VideoForm from './pages/VideoForm';
import VideoDetail from './pages/VideoDetail';
import Playlists from './pages/Playlists';
import PlaylistForm from './pages/PlaylistForm';
import PlaylistDetail from './pages/PlaylistDetail';
import Help from './pages/Help';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/*
            The client Training Library deliberately sits outside the Video Hub
            admin route because it is opened from a client application. A direct
            browser visit remains locked: the component renders content only after
            its opener/parent supplies an authorised library payload.
          */}
          <Route path="/training/:libraryKey" element={<TrainingLibrary />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />

            <Route path="apps" element={<Apps />} />
            <Route path="apps/:id/setup" element={<AppSetup />} />

            <Route path="videos" element={<Videos />} />
            <Route path="videos/new" element={<VideoForm />} />
            <Route path="videos/:id" element={<VideoDetail />} />
            <Route path="videos/:id/edit" element={<VideoForm />} />

            <Route path="playlists" element={<Playlists />} />
            <Route path="playlists/new" element={<PlaylistForm />} />
            <Route path="playlists/:id" element={<PlaylistDetail />} />
            <Route path="playlists/:id/edit" element={<PlaylistForm />} />

            <Route path="help" element={<Help />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;